




































import { Vue, Component, Prop } from 'vue-property-decorator';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import StepsIndicator from '@/views/Onboarding/Steps/StepsIndicator/StepsIndicator.vue';

import OfferCreationStep1 from './OfferCreationStep1.vue';
import OfferCreationStep2 from './OfferCreationStep2.vue';
import {
  CustomerImportFormData,
  ECustomerImportSteps
} from '../CustomerImportModal.vue';
import CustomerImportService from '@/api/CustomerImportService';
import BackModal from '@/components/icons/BackModal.vue';
import { StartGuideTask } from '@/models/start-guide';

type FormData = {
  coins: number | null;
  eligibleCustomersAmount: number;
  loading?: boolean;
};

@Component({
  components: {
    CloseModalIcon,
    OfferCreationStep1,
    OfferCreationStep2,
    StepsIndicator,
    BackModal
  }
})
export default class OfferCreation extends Vue {
  @Prop() customerImportFormData!: CustomerImportFormData;
  @Prop() startGuideTaskSlug?: StartGuideTask;

  customerImportService = new CustomerImportService();

  formData: FormData = {
    coins: null,
    eligibleCustomersAmount: 0,
    loading: false
  };

  step = {
    main: 1,
    internal: 0,
    currentIndex: 0
  };
  stepMapper: Record<number, any> = {
    1: {
      components: [{ component: 'OfferCreationStep1' }]
    },
    2: {
      components: [{ component: 'OfferCreationStep2' }]
    }
  };

  get steps() {
    return Object.entries(this.stepMapper).reduce((acc, curr) => {
      const [key, value] = curr;

      return {
        ...acc,
        [Number(key)]: {
          componentName: value.components[0].component
        }
      };
    }, {});
  }

  get isLastStep() {
    return this.step.main === Object.keys(this.stepMapper).length;
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get serviceMapper(): Record<string, any> {
    return {
      getElegibleCustomers: this.getElegibleCustomers
    };
  }

  async getElegibleCustomers() {
    if (this.formData.eligibleCustomersAmount) return;

    this.formData.loading = true;

    const { data } = await this.customerImportService.getElegibleCustomers(
      this.currentProvider.name
    );

    this.formData.eligibleCustomersAmount = data.eligibleCustomerAmount;

    this.formData.loading = false;
  }

  handleClose() {
    this.$emit('customer-import-event', { type: 'closeModal' });
  }

  handleBack() {
    if (this.step.main > 1) {
      this.step.main--;
    }
  }

  async sendCampaignData() {
    if (!this.formData.coins) return;

    const payload = {
      coinsReward: this.formData.coins
    };

    this.formData.loading = true;

    await this.customerImportService.createCampaign({
      payload,
      providerName: this.currentProvider.name
    });

    this.formData.loading = false;

    this.$emit('customer-import-event', {
      type: !this.startGuideTaskSlug ? 'goToStep' : 'startGuideUpdateTasks',
      params: { goToStep: ECustomerImportSteps.SUCCESS }
    });
  }

  async handleNext(service?: string) {
    if (this.isLastStep) {
      this.sendCampaignData();

      return;
    }

    if (service && this.serviceMapper[service]) {
      await this.serviceMapper[service]();
      this.step.main++;

      return;
    }

    this.step.main++;
  }

  async handleSubmit(formData?: { coins: string; service?: string }) {
    if (formData) {
      this.formData.coins = Number(formData.coins);
    }

    await this.handleNext(formData && formData.service ? formData.service : '');
  }
}
